const main = {
  'App support link':
    'https://support.shoplineapp.com/hc/en-us/articles/23966890906649',
  'Config GMC': 'Google Merchant Center - Shopping Ads Setting',
  'Config GMC Caption':
    'This integration uploads your product data through Google Content API to Google Merchant Center, making it available to Google Ads and other Google services. To connect to this service, please link a Google Merchant Center sub-account ID.',
  'Merchant Center ID': 'Google Merchant ID',
  'Merchant Center ID - description_unintegrated':
    'Your shop is not yet connected with a verified Google Merchant Center account.\nGo to Settings > Basic settings > Third Party Domain Tools > Google Merchat Center to set up connection',
  'Merchant Center ID - description_integrated':
    'Once you enable Content API, your product information will be shared with the verified Google Merchant Center account shown below.',
  'Merchant Center ID - action button_unintegrated': 'Setup Now',
  'Merchant Center ID - action button_integrated': 'See Settings',
  'Preorder Period': 'Availability Date',
  'Merchant has been saved successfully':
    'Merchant has been saved successfully',
  'Failed to save merchant': 'Failed to save merchant',
  'Failed to connect with MCA merchant':
    'Fail to connect, do not use a MCA(multi-client account) to do the connection',
  'Failed to connect with invalid domain':
    'Fail to connect, please check the domain verification status of your Google Merchant Center account',
  'Successfully set the Region and Language for Ads Delivery':
    'Successfully set the Region and Language for Ads Delivery',
  'Please enter numbers only': 'Please Enter a valid GMC ID',
  'The shipping delay days cannot be left blank or set to fewer than 30.':
    'The shipping delay days cannot be left blank or set to fewer than 30.',
  'Upload products to GMC': 'Upload products to GMC',
  'Upload products to GMC - description':
    'Please be sure to copy and add the following link to Google Merchant Center to successfully use the Content API to instantly upload products to GMC.',
  'Upload products to GMC - step 1':
    '1. Click the icon on the right to copy Email',
  'Upload products to GMC - step 2':
    '2. Go to Google Merchant Center > Tools and Settings (click the middle gear icon in the upper right corner) > Account Access > Users',
  'Upload products to GMC - step 3':
    '3. Add a new user and share administrator rights to the user',
  'Save before leaving': 'Please save any changes before leaving the page.',
  'Authorize Content API Title': 'Authorize Content API service account access',
  'Authorize Content API Description':
    'Please follow the <1>FAQ</1> instructions, go to Google Merchant Center to create Service Account Credentials & download the json key file.',
  'Content API FAQ Link':
    'https://support.shoplineapp.com/hc/en-us/articles/23966890906649',
  'Upload Files Here': 'Upload Files Here',
  'Invalid Credential File':
    'Credential file is not valid, please check or create a new credential key.',

  'Config region & locale': 'Region and Language Settings for Ads Delivery',
  'Config region & locale Caption':
    'After connecting to Google Merchant Center, product feeds delivery through Content API can be managed here and will be updated on time. Google Merchant Center will display your Shopping Ads based on your Region & Language Settings.',
  'Config region & locale Alert':
    'Please enter the product name, summary, and description for the selected placement language to ensure successful product uploads.',
  'Signed in with Google': 'Signed in with Google',
  "You're signed in with Google": "You're signed in with Google",
  'Automatically connect Merchant API — no manual setup required':
    'Automatically connect Merchant API — no manual setup required',
  'Go to Google Merchant Center': 'Go to Google Merchant Center',
  'Sign in with your Google account': 'Sign in with your Google account',
  'Sign in with Google': 'Sign in with Google',
  'Learn more': 'Learn more',
  'When your store is connected to a Google Merchant Center account, disconnecting it will have the following effects:':
    'When your store is connected to a Google Merchant Center account, disconnecting it will have the following effects:',
  'Website ownership will be transferred to the new GMC account.':
    'Website ownership will be transferred to the new GMC account.',
  'Product data will be synced to the new GMC account.':
    'Product data will be synced to the new GMC account.',
  'Products in the original GMC account will be marked as "Disapproved".':
    'Products in the original GMC account will be marked as "Disapproved".',
  'Ad campaigns linked to the original GMC account will be interrupted.':
    'Ad campaigns linked to the original GMC account will be interrupted.',
  'The original GMC account will be deactivated and can no longer be used.':
    'The original GMC account will be deactivated and can no longer be used.',
  'A GMC sub-account has been created in your SHOPLINE MCA':
    'A GMC sub-account has been created in your SHOPLINE MCA',
  'Create and connect Google Merchant Center account':
    'Create and connect Google Merchant Center account',
  'We will help you create a new GMC account using your authorized Google account and automatically connect it to SHOPLINE.':
    'We will help you create a new GMC account using your authorized Google account and automatically connect it to SHOPLINE.',
  'Connect now': 'Connect now',
  'A new Merchant Center account has been created and connected to your store. Please check your inbox and accept the Google Merchant Center admin invitation.':
    'A new Merchant Center account has been created and connected to your store. Please check your inbox and accept the Google Merchant Center admin invitation.',
  'Website ownership has been transferred to this account.':
    'Website ownership has been transferred to this account.',
  'Product data will be synced to this account.':
    'Product data will be synced to this account.',
  'Connected Merchant Center ID': 'Connected Merchant Center ID',
  Disconnect: 'Disconnect',
  'Disconnect Google Merchant Center account?':
    'Disconnect Google Merchant Center account?',
  'Confirm Disconnect': 'Disconnect',
  'Product data will stop syncing, and any ads linked to this account will be paused. Are you sure you want to disconnect from Google Merchant Center?':
    'Product data will stop syncing, and any ads linked to this account will be paused. Are you sure you want to disconnect from Google Merchant Center?',
  'Let Google Merchant Center determine the shipping date for pre-order products.':
    'Let Google Merchant Center determine the shipping date for pre-order products.',
  'Connect Merchant API': 'Connect Merchant API',
  'Through a Merchant API connection, your product data will be automatically uploaded to Google Merchant Center, allowing them to be accessible in Google Ads, YouTube Live Shopping, and other Google features.':
    'Through a Merchant API connection, your product data will be automatically uploaded to Google Merchant Center, allowing them to be accessible in Google Ads, YouTube Live Shopping, and other Google features.',
  'Connect Merchant API Label': 'Connect Merchant API',
  Recommended: 'Recommended',
  'Recommended for real-time product sync, hidden product setting, and simplified maintenance.':
    'Recommended for real-time product sync, hidden product setting, and simplified maintenance.',
  'Do not connect Merchant API': 'Do not connect Merchant API',
  'Product data will not sync automatically. You must manually update the Product Feed in Google Merchant Center. This may affect product approval and exposure.':
    'Product data will not sync automatically. You must manually update the Product Feed in Google Merchant Center. This may affect product approval and exposure.',
  'Saved successfully': 'Saved successfully',
  'Setup incomplete': 'Setup incomplete',
  'Placement area and placement language are not configured':
    'Placement area and placement language are not configured',
  'Merchant API settings not saved': 'Merchant API settings not saved',
  'The system will temporarily save your settings as "Not connected to Merchant API".':
    'The system will temporarily save your settings as "Not connected to Merchant API".',
  'Apps Store': 'Apps Store',
  'My Apps': 'My Apps',
  'If you need to manage the Google Merchant Center account, please contact the account owner and request manual authorization in the Google Merchant Center dashboard.':
    'If you need to manage the Google Merchant Center account, please contact the account owner and request manual authorization in the Google Merchant Center dashboard.',
  'Are you sure you want to cancel?': 'Are you sure you want to cancel?',
  'Any unsaved changes will be lost.': 'Any unsaved changes will be lost.',
  'Continue editing': 'Continue editing',
  'Cancel changes': 'Confirm',
  "Your edits aren't saved": "Your edits aren't saved",
  'If you leave, any unsaved changes will be lost. Please save before leaving.':
    'If you leave, any unsaved changes will be lost. Please save before leaving.',
  Leave: 'Leave',
  'Once you sign in, the Merchant API will be automatically connected to SHOPLINE with no manual setup needed. Your product data will be automatically uploaded to Google Merchant Center, allowing them to be accessible in Google Ads, YouTube Live Shopping, and other Google features.':
    'Once you sign in, the Merchant API will be automatically connected to SHOPLINE with no manual setup needed. Your product data will be automatically uploaded to Google Merchant Center, allowing them to be accessible in Google Ads, YouTube Live Shopping, and other Google features.',
  'Once you sign in, We will help you create and connect the Merchant Center account.':
    'Once you sign in, We will help you create and connect the Merchant Center account.',
  'Your store is currently connected to Google Merchant Center (GMC). Signing in will disconnect the existing GMC account and automatically create and connect a new one.':
    'Your store is currently connected to Google Merchant Center (GMC). Signing in will disconnect the existing GMC account and automatically create and connect a new one.',
  'Ad Placement Area and Language': 'Ad Placement Area and Language',
  'The system will upload your products (including preorder and hidden products) to Google Merchant Center. Product ads will be displayed based on the selected placement area and language.':
    'The system will upload your products (including preorder and hidden products) to Google Merchant Center. Product ads will be displayed based on the selected placement area and language.',
  'Please enter the product name, summary, and description for the selected placement language to ensure successful product uploads.':
    'Please enter the product name, summary, and description for the selected placement language to ensure successful product uploads.',
  Region: 'Placement Area',
  Locale: 'Placement Language',
  'Add a language to the list below': 'Add a language to the list below',
  'EmptyLocale - title': 'There’s no data yet',
  'EmptyLocale - subtitle': 'Add a language from above settings',
  'Please contact the Online Merchant Success Team to enable this feature for your store.':
    'Please contact the Online Merchant Success Team to enable this feature for your store.',
  'To reconnect to Google Merchant Center, a new GMC account will be created following the new process to comply with Google\'s latest API standards. Please contact the Online Merchant Success Team to enable the "Automatically create and connect Merchant API" feature.':
    'To reconnect to Google Merchant Center, a new GMC account will be created following the new process to comply with Google\'s latest API standards. Please contact the Online Merchant Success Team to enable the "Automatically create and connect Merchant API" feature.',
  'Sign in and authorize now to upgrade from Content API to Merchant API':
    'Sign in and authorize now to upgrade from Content API to Merchant API',
  'Due to Google policy changes, the Content API will be deprecated on 18 August 2026, and replaced by the Merchant API.':
    'Due to Google policy changes, the Content API will be deprecated on 18 August 2026, and replaced by the Merchant API.',
  'Please complete the API upgrade as soon as possible to prevent any disruption to product uploads and ad delivery.':
    'Please complete the API upgrade as soon as possible to prevent any disruption to product uploads and ad delivery.',
  'Once authorized, you can upgrade to the Merchant API instantly with no manual setup required.':
    'Once authorized, you can upgrade to the Merchant API instantly with no manual setup required.',
  "We recommend that the store owner perform the authorization to avoid disruptions caused by changes to a staff member's account status or permissions.":
    "We recommend that the store owner perform the authorization to avoid disruptions caused by changes to a staff member's account status or permissions.",
  "If the authorized staff member's GMC account is suspended or permissions change, product uploads and ad delivery will be affected. If any changes occur, please contact the Online Merchant Success Team.":
    "If the authorized staff member's GMC account is suspended or permissions change, product uploads and ad delivery will be affected. If any changes occur, please contact the Online Merchant Success Team.",
  'Google discontinued the Content API on 18 August 2026. Please upgrade to the Merchant API to keep syncing product data with your GMC account.':
    'Google discontinued the Content API on 18 August 2026. Please upgrade to the Merchant API to keep syncing product data with your GMC account.',
  'Successfully upgraded to Merchant API':
    'Successfully upgraded to Merchant API',
  'Content API has been upgraded to Merchant API. Your previous settings have been automatically applied. No reconfiguration is needed.':
    'Content API has been upgraded to Merchant API. Your previous settings have been automatically applied. No reconfiguration is needed.',
  'Upgrade Content API to Merchant API': 'Upgrade Content API to Merchant API',
  'If you need to disconnect Google Merchant Center, please contact the Online Merchant Success Team for assistance.':
    'If you need to disconnect Google Merchant Center, please contact the Online Merchant Success Team for assistance.',
  'Disconnect Google Merchant Center?': 'Disconnect Google Merchant Center?',
  'Product data syncing will stop, and ads linked to this account will be interrupted.':
    'Product data syncing will stop, and ads linked to this account will be interrupted.',
  'Your current Google account does not have administrative access to this GMC account. Please contact the store owner for authorization.':
    'Your current Google account does not have administrative access to this GMC account. Please contact the store owner for authorization.',
  'Insufficient permissions. Please log in to Google again and grant the required access.':
    'Insufficient permissions. Please log in to Google again and grant the required access.',
  DATA_TABLE: {
    REGION: 'Region',
    LOCALE: 'Language',
    ACTION: 'Turn On/Off',
  },
  LOCALE: {
    'zh-hant': 'Chinese - Taiwan',
    'zh-tw': 'Chinese - Taiwan',
    'zh-hk': 'Chinese - Hong Kong SAR',
    'zh-cn': 'Chinese - China',
    en: 'English',
    ms: 'Malay',
    th: 'Thai',
    vi: 'Vietnamese',
    id: 'Indonesian',
    de: 'German',
    fr: 'French',
    ja: 'Japanese',
  },
  REGION: {
    TW: 'Taiwan',
    CN: 'China',
    HK: 'Hong Kong',
    JP: 'Japan',
    SG: 'Singapore',
    MY: 'Malaysia',
    TH: 'Thailand',
    VN: 'Vietnam',
    PH: 'Philippines',
    US: 'USA',
    AU: 'Australia',
    GB: 'UK',
  },
  UNIT: {
    days: 'days',
  },
};

export default main;
